var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-tree-manager',{attrs:{"title":"品类结构","loading":_vm.loading,"data":_vm.data,"collapse-icon":"","homeIcon":"","expand-icon":""},on:{"queryData":_vm.queryData,"node-click":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }